import type { FragmentType } from "@repo/graphql-types";
import { graphql, useFragment } from "@repo/graphql-types";
import { Link } from "@tanstack/react-router";
import { CardRoot, CardContent } from "@/components/card";
import {
  PublicPhoneNumberCardHeader,
  PublicPhoneNumberCardDescription,
  PublicPhoneNumberSection,
  PublicPhoneNumberPendingSection,
} from "@/components/phone-number-card";

export const PublicPhoneNumberFragment = graphql(`
    fragment PublicPhoneNumberFragment on query_root {
        usuariosProfissionais {
            telefonePublico
        }
    }
`);

interface PublicPhoneNumberCardProps {
  data: FragmentType<typeof PublicPhoneNumberFragment>;
}

export const PublicPhoneNumberCard = ({
  data,
}: PublicPhoneNumberCardProps): JSX.Element => {
  const fragmentData = useFragment(PublicPhoneNumberFragment, data);
  
  const phone = fragmentData.usuariosProfissionais[0]?.telefonePublico ?? "";
  const hasNumber = Boolean(phone);

  return (
    <Link to="/settings/profile/upsert-public-phone">
      <CardRoot>
        <CardContent className="flex flex-col justify-center items-start w-full">
          <PublicPhoneNumberCardHeader hasNumber={hasNumber} />
          {hasNumber ? (
            <>
              <PublicPhoneNumberSection phone={phone} />
              <PublicPhoneNumberCardDescription hasNumber />
            </>
          ) : (
            <>
              <PublicPhoneNumberPendingSection />
              <PublicPhoneNumberCardDescription hasNumber={false} />
            </>
          )}
        </CardContent>
      </CardRoot>
    </Link>
  );
};
